// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"72e0d450","268":"b978231e","453":"c1d26ca4","484":"7921730b","551":"c9f81bd6","640":"c8264be3","851":"9ef7ce22","952":"8b032712"}[chunkId] + ".chunk.js";
};